import React, { useState, useEffect, useRef } from "react";
import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  getBookingDetail,
  addReviewAction,
  getReviewListAction,
  getYachtAction,
  getBookingHistoryDetail,
  getBookCustomerDetailAction,
  sendReviewChatAction,
  getReviewChatAction,
  getUnreadReviewChatAction,
} from "../../../../redux/booking/BookingSlice";
import detailYachtInformation from "../../../../redux/yachtInformation/YachtInformationSlice";
import {
  FaStar,
  FaMapMarkerAlt,
  FaRegCommentDots,
  FaPaperPlane,
  FaPaperclip,
  FaImage,
  FaSmile
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import { Pagination } from "react-bootstrap";
import Sail from "../../../../Asset/image/yacht/Sail.gif";
import EmojiPicker from "emoji-picker-react";

const Reviews = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const todos = useSelector((state) => state);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("toBeReviewed");
  const [expanded, setExpanded] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [chatMessage, setChatMessage] = useState("");
  const [chatFiles, setChatFiles] = useState([]);
  // const [chatMessages, setChatMessages] = useState([]);
  const [showEmoji, setShowEmoji] = useState(false);
  const [selectedChatDelete, setSelectedChatDelete] = useState(null);
  const getToken = useSelector((state) => state.AuthSlice.token);
  const idUserTMY = useSelector((state) => state.AuthSlice.user?.idUserTMY);

  const reviewChat = todos.Booking.reviewChat?.data || [];
  const unreadReviewChat =
    todos.Booking.unreadReviewChat?.data || [];
  const review = todos.Booking.reviewList.data;
  const yacht = todos.YachtInformationSlice.YachtInformation.results;
  const booking = todos.Booking.Booking.results;
  const history = todos.Booking.BookingHistroy.results;
  const yachttour = todos.Booking.yachtResult.data;
  const customerDetails = todos.Booking.bookCustomerDetailList.data;
  const marinaLookup = todos.CenterDataSlice.Marina?.results;
  const provinceLookup = todos.CenterDataSlice.Province?.results;

  console.log("unreadReviewChat", unreadReviewChat);
  console.log("idUserTMY =", idUserTMY);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const chatBottomRef = useRef(null);

  const emojiContainerRef = useRef(null);

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setChatFiles([file]);
  };

  const handleRemoveFile = () => {
    setChatFiles([]);
  };


  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleSendChat = async () => {

    if (chatMessage.length === 0 && chatFiles.length === 0) return;


    let base64File = null;


    if (chatFiles.length > 0) {

      base64File = await convertFileToBase64(chatFiles[0]);

    }


    const payload = {
      id_review: selectedReview.id_review,
      sender_type: "customer",
      sender_id: idUserTMY,

      message: chatMessage || null,

      file_url: base64File,

      file_name:
        chatFiles.length > 0
          ? chatFiles[0].name
          : null,

      file_type:
        chatFiles.length > 0
          ? chatFiles[0].type
          : null
    };


    await dispatch(sendReviewChatAction(payload));

    await dispatch(
      getReviewChatAction({
        id_review: selectedReview.id_review,
        reader: "customer",
      })
    );


    setChatMessage("");
    setChatFiles([]);

  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // โหลดครั้งแรก → เปิด overlay
        setLoading(true);

        await Promise.all([
          dispatch(getReviewListAction({})),
          dispatch(getYachtAction({})),
          // dispatch(detailYachtInformation({})),
          dispatch(getBookingHistoryDetail({ token: getToken })),
          dispatch(getBookCustomerDetailAction({})),
          dispatch(getBookingDetail({})),
          dispatch(getUnreadReviewChatAction({
            idUserTMY
          })),
        ]);

        // โหลดเสร็จ → ปิด overlay
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false); // กันเผื่อ error แล้ว overlay ไม่หาย
      }
    };
    fetchData();
  }, [dispatch, getToken]);

  useEffect(() => {
    if (!openChat || !selectedReview) return;

    const interval = setInterval(async () => {
      await dispatch(
        getReviewChatAction({
          id_review: selectedReview.id_review,
          reader: "customer",
        })
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [openChat, selectedReview, dispatch]);

  useEffect(() => {
    if (loading) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [loading]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(getReviewListAction({}));
    }, 5000);

    return () => clearInterval(intervalId);
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showEmoji &&
        emojiContainerRef.current &&
        !emojiContainerRef.current.contains(event.target)
      ) {
        setShowEmoji(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmoji]);

  useEffect(() => {

    const interval = setInterval(() => {

      dispatch(
        getUnreadReviewChatAction({
          idUserTMY
        })
      );

    }, 3000);

    return () => clearInterval(interval);

  }, [dispatch]);

  useEffect(() => {
    if (openChat && chatBottomRef.current) {
      setTimeout(() => {
        chatBottomRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }, 100);
    }
  }, [openChat]);

  const [ratings, setRatings] = useState({});
  const [messages, setMessages] = useState({});
  const [hovers, setHovers] = useState({});

  const [toBeReviewPage, setToBeReviewPage] = useState(1);
  const [historyPage, setHistoryPage] = useState(1);
  const itemsPerPage = 5; // จำนวน item ต่อหน้า

  function getFlexibleDistanceToNow(date) {
    if (!date || isNaN(date)) return "-";

    const now = new Date();

    const startOfDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    const diffMs = now - startOfDay;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return `${diffHours} ${diffHours === 1 ? t("hour ago") : t("hours ago")}`;
    } else if (diffDays < 7) {
      return `${diffDays} ${diffDays === 1 ? t("day ago") : t("days ago")}`;
    } else if (diffDays < 365) {
      const weeks = Math.floor(diffDays / 7);
      return `${weeks} ${weeks === 1 ? t("week ago") : t("weeks ago")}`;
    } else {
      const years = Math.floor(diffDays / 365);
      return `${years} ${years === 1 ? t("year ago") : t("years ago")}`;
    }
  }

  function getLocalizedMarina(marinaValue) {
    if (!marinaValue || !marinaLookup || !provinceLookup) {
      return marinaValue;
    }

    // แยก pier ถ้ามี, format เป็น "pier / Marina, Province"
    let pierPart = "";
    let restPart = marinaValue;

    if (marinaValue.includes(" / ")) {
      [pierPart, restPart] = marinaValue.split(" / ").map((s) => s.trim());
    }

    const [marinaEn, provinceEn] = restPart.split(",").map((s) => s.trim());

    const marinaObj = marinaLookup.find((m) => m.name_marina_en === marinaEn);
    const provinceObj = provinceLookup.find(
      (p) => p.ProvinceEng === provinceEn
    );

    if (i18n.language === "th") {
      const marinaTh = marinaObj?.name_marina_th || marinaEn;
      const provinceTh = provinceObj?.ProvinceThai || provinceEn;

      return pierPart
        ? `${pierPart} / ${marinaTh}, ${provinceTh}`
        : `${marinaTh}, ${provinceTh}`;
    }

    const marinaName = marinaObj?.name_marina_en || marinaEn;
    const provinceName = provinceObj?.ProvinceEng || provinceEn;

    return pierPart
      ? `${pierPart} / ${marinaName}, ${provinceName}`
      : `${marinaName}, ${provinceName}`;
  }

  const handleSubmit = async (bookingId) => {
    const rating = ratings[bookingId];
    const message = messages[bookingId] || "";

    if (!rating) {
      setSnackbar({
        open: true,
        message: t("Please select a rating."),
        severity: "warning",
      });
      return;
    }

    const matchedCustomer = customerDetails.find(
      (cd) => Number(cd.id_booking) === Number(bookingId)
    );
    const customerDetailId = matchedCustomer?.id_bookCustomerdetail;

    if (!customerDetailId) {
      setSnackbar({
        open: true,
        message: t("Customer detail not found."),
        severity: "error",
      });
      return;
    }
    if (!idUserTMY) {
      setSnackbar({
        open: true,
        message: t("User not logged in."),
        severity: "error",
      });
      return;
    }

    const payload = {
      id_booking: bookingId,
      id_bookCustomerdetail: customerDetailId,
      idUserTMY,
      rating,
      comment: message,
    };

    try {
      await dispatch(addReviewAction(payload));
      setSnackbar({
        open: true,
        message: t("Review submitted successfully!"),
        severity: "success",
      });
    } catch (error) {
      console.error("Error submitting review:", error);
      setSnackbar({
        open: true,
        message: t("An error occurred while submitting your review."),
        severity: "error",
      });
    }
  };

  const renderPagination = (totalItems, currentPage, setPage) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (totalPages <= 1) return null;

    const handlePreviousPage = () => {
      if (currentPage > 1) setPage(currentPage - 1);
    };

    const handleNextPage = () => {
      if (currentPage < totalPages) setPage(currentPage + 1);
    };

    const handlePageChange = (pageNumber) => {
      setPage(pageNumber);
    };

    // ✅ Pagination UI ใหม่แบบวงกลม + ellipsis
    return (
      <Pagination className="d-flex justify-content-center circular-pagination mt-4">
        <Pagination.Item
          className="prev"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
        >
          &lt;
        </Pagination.Item>

        {Array.from({ length: totalPages }, (_, index) => index + 1)
          .filter((number) => {
            return (
              number === 1 ||
              number === totalPages ||
              (number >= currentPage - 1 && number <= currentPage + 1)
            );
          })
          .reduce((acc, number, idx, arr) => {
            if (idx > 0 && number - arr[idx - 1] > 1) {
              acc.push("ellipsis");
            }
            acc.push(number);
            return acc;
          }, [])
          .map((item, idx) =>
            item === "ellipsis" ? (
              <Pagination.Ellipsis key={`ellipsis-${idx}`} disabled />
            ) : (
              <Pagination.Item
                key={item}
                active={item === currentPage}
                onClick={() => handlePageChange(item)}
              >
                {item}
              </Pagination.Item>
            )
          )}

        <Pagination.Item
          className="next"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          &gt;
        </Pagination.Item>
      </Pagination>
    );
  };

  const renderTabContent = () => {
    if (activeTab === "toBeReviewed") {
      const completedHistories =
        history?.filter((h) => h.status === "COMPLETED") || [];

      const reviewedBookingIds =
        (review || [])
          .filter((r) => Number(r.idUserTMY) === Number(idUserTMY))
          .map((r) => r.id_booking) || [];

      const seen = new Set();
      const unreviewedCompleted = (completedHistories || [])
        .filter((h) => !reviewedBookingIds.includes(Number(h.id_booking)))
        .filter((h) => {
          const alreadySeen = seen.has(h.id_booking);
          seen.add(h.id_booking);
          return !alreadySeen;
        });

      if (!unreviewedCompleted || unreviewedCompleted.length === 0) {
        return (
          <div className="text-center-mt-10vh">
            <div className="text-gray-light">
              {t("your feedbacks help others make better service choices")}
            </div>
          </div>
        );
      }

      const startIndex = (toBeReviewPage - 1) * itemsPerPage;
      const currentItems = unreviewedCompleted.slice(
        startIndex,
        startIndex + itemsPerPage
      );

      return (
        <div className="mt-4vh-px16">
          {currentItems.map((historyItem, idx) => {
            const matchedBooking = booking?.find(
              (b) => Number(b.id_booking) === Number(historyItem.id_booking)
            );

            const matchedYacht = matchedBooking
              ? yacht?.find(
                (y) =>
                  Number(y.id_yachtInfo) ===
                  Number(matchedBooking.id_yachtInfo)
              )
              : null;

            const matchedTour = yachttour?.find(
              (yt) => yt.id_yacht === matchedYacht?.id_yacht
            );

            const matchedCustomer = customerDetails?.filter(
              (cd) =>
                Number(cd.id_booking) === Number(matchedBooking?.id_booking)
            );

            return (
              <div
                key={idx}
                className="card-flex-wrap"
              >
                {/* ฝั่งซ้าย: ข้อมูลเรือ */}
                <div
                  className="flex-gap"
                >
                  <img
                    src={matchedYacht?.logo_yachtInfo_url || "/placeholder.jpg"}
                    alt="yacht"
                    className="img-thumb"
                  />

                  <div
                    className="flex-column-center-text"
                  >
                    <div
                      className="flex-row-gap-20"
                    >
                      <div className="text-left">
                        <div
                          className="text-title"
                        >
                          {matchedYacht?.name_yacht_yachtInfo ||
                            "Unnamed Yacht"}
                        </div>

                        <div className="text-muted-sm">
                          <FaMapMarkerAlt />{" "}
                          {getLocalizedMarina(matchedYacht?.value_marina)}
                        </div>

                        <div
                          className="text-link-small"
                        >
                          {t("Operated by")}{" "}
                          {matchedTour
                            ? matchedTour.name_yacht
                            : "Travel Agent"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ฝั่งขวา: ช่องกรอก review */}
                <div
                  className="flex-box"
                >
                  <div
                    className="border-right-padding"
                  >
                    <div className="text-left-pr5">
                      <div
                        className="text-bold-16"
                      >
                        ฿
                        {Number(
                          matchedBooking?.sum_all_price || 0
                        ).toLocaleString()}
                      </div>

                      {matchedBooking?.activity_type && (
                        <div className="text-muted-sm">
                          {t(matchedBooking.activity_type)}
                        </div>
                      )}

                      {matchedBooking?.activity_date && (
                        <div className="text-muted-sm">
                          {t("Date Booking")}: {matchedBooking.activity_date}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="pl-20">
                    <div
                      className="flex-gap-5 mb-10"
                    >
                      {[...Array(5)].map((_, i) => {
                        const currentRating = i + 1;
                        const bookingId = historyItem.id_booking;

                        return (
                          <FaStar
                            key={i}
                            size={20}
                            color={
                              currentRating <=
                                (hovers[bookingId] || ratings[bookingId])
                                ? "#ffc107"
                                : "#e4e5e9"
                            }
                            className="cursor-pointer"
                            onClick={() =>
                              setRatings((prev) => ({
                                ...prev,
                                [bookingId]: currentRating,
                              }))
                            }
                            onMouseEnter={() =>
                              setHovers((prev) => ({
                                ...prev,
                                [bookingId]: currentRating,
                              }))
                            }
                            onMouseLeave={() =>
                              setHovers((prev) => ({
                                ...prev,
                                [bookingId]: null,
                              }))
                            }
                          />
                        );
                      })}
                    </div>

                    <textarea
                      placeholder={t("Write your comment here...")}
                      rows={3}
                      className="textarea-default"
                      value={messages[historyItem.id_booking] || ""}
                      onChange={(e) =>
                        setMessages((prev) => ({
                          ...prev,
                          [historyItem.id_booking]: e.target.value,
                        }))
                      }
                    />

                    <button
                      className="btn-primary-full"
                      onClick={() => handleSubmit(historyItem.id_booking)}
                    >
                      {t("Review")}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}

          {renderPagination(
            unreviewedCompleted.length,
            toBeReviewPage,
            setToBeReviewPage
          )}
        </div>
      );
    } else if (activeTab === "history") {
      const userReviews = review?.filter(
        (r) => Number(r.idUserTMY) === Number(idUserTMY) &&
          Number(r.show_review) === 1
      );

      if (!userReviews || userReviews.length === 0) {
        return (
          <div
            className="text-center-mt10vh-gray"
          >
            {t("No review history yet.")}
          </div>
        );
      }

      const startIndex = (historyPage - 1) * itemsPerPage;
      const currentItems = userReviews.slice(
        startIndex,
        startIndex + itemsPerPage
      );

      const lastCustomerMessage = [...reviewChat]
        .reverse()
        .find(m => m.sender_type === "customer");

      return (
        <div className="mt-4vh-px16">
          {currentItems.map((item, idx) => {
            const matchedBooking = booking.find(
              (b) => Number(b.id_booking) === Number(item.id_booking)
            );

            const matchedYacht = matchedBooking
              ? yacht.find(
                (y) =>
                  Number(y.id_yachtInfo) ===
                  Number(matchedBooking.id_yachtInfo)
              )
              : null;

            const matchedTour = yachttour.find(
              (yt) => yt.id_yacht === matchedYacht?.id_yacht
            );

            const isUrl = (text) => {
              try {
                new URL(text);
                return true;
              } catch {
                return false;
              }
            };

            const openFile = (base64, fileType, fileName) => {
              try {
                const byteString = atob(base64.split(",")[1]);
                const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];

                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);

                for (let i = 0; i < byteString.length; i++) {
                  ia[i] = byteString.charCodeAt(i);
                }

                const blob = new Blob([ab], {
                  type: fileType || mimeString,
                });

                const url = URL.createObjectURL(blob);

                window.open(url, "_blank");

                setTimeout(() => {
                  URL.revokeObjectURL(url);
                }, 10000);
              } catch (err) {
                console.log(err);
              }
            };

            return (
              <div
                key={idx}
                className="flex-card-wrap"
              >
                {/* 🔹 ฝั่งซ้าย: รวมข้อมูลทั้งหมดของเรือ */}
                <div className="flex-gap-16">
                  <img
                    src={matchedYacht?.logo_yachtInfo_url || "/placeholder.jpg"}
                    alt="yacht"
                    className="img-thumb-sm"
                  />

                  <div
                    className="flex-col-center-text"
                  >
                    <div
                      className="flex-row-gap-20"
                    >
                      <div
                        className="text-wrap-left"
                      >
                        <div
                          className="title-wrap"
                        >
                          {matchedYacht?.name_yacht_yachtInfo ||
                            "Unnamed Yacht"}
                        </div>

                        <div
                          className="text-muted-wrap"
                        >
                          <FaMapMarkerAlt />{" "}
                          {getLocalizedMarina(matchedYacht?.value_marina)}
                        </div>

                        <div
                          className="text-link-end"
                        >
                          {t("Operated by")}{" "}
                          {matchedTour
                            ? matchedTour.name_yacht
                            : "Travel Agent"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 🔹 ฝั่งขวา: รีวิว + คอมเมนต์ */}
                <div
                  className="flex-responsive-box"
                >
                  <div
                    className="text-left-border-col"
                  >
                    <div
                      className="text-bold-16"
                    >
                      ฿
                      {Number(
                        matchedBooking?.sum_all_price || 0
                      ).toLocaleString()}
                    </div>

                    {matchedBooking?.activity_type && (
                      <div className="text-muted-14">
                        {t(matchedBooking.activity_type)}
                      </div>
                    )}

                    {matchedBooking?.activity_date && (
                      <div
                        className="text-muted-prewrap"
                      >
                        {t("Date Booking")}:{" "}
                        {String(matchedBooking.activity_date)
                          .split(",")
                          .map((date, i) => (
                            <div key={i}>{date.trim()}</div>
                          ))}
                      </div>
                    )}
                  </div>

                  <div className="pl-20">
                    <div
                      className="flex-wrap-gap"
                    >
                      {/* ✅ กล่องดาวให้เรียงเป็นแนวนอน */}
                      <div className="flex-gap-4">
                        {[...Array(5)].map((_, i) => (
                          <FaStar
                            key={i}
                            size={16}
                            color={i < item.rating ? "#f5c518" : "#e4e5e9"}
                          />
                        ))}
                      </div>

                      {/* ✅ ข้อความอยู่ใต้ดาว */}
                      <span
                        className="text-sm-medium"
                      >
                        {item.rating === 5
                          ? t("Delighted")
                          : item.rating === 4
                            ? t("Satisfied")
                            : item.rating === 3
                              ? t("Fair")
                              : item.rating === 2
                                ? t("Dissatisfied")
                                : t("Extremely Bad")}
                      </span>
                    </div>

                    <div
                      className="text-expandable"
                      style={{
                        maxHeight: expanded ? "none" : "40px",
                      }}
                    >
                      {item.comment || "-"}
                    </div>

                    {item.comment && item.comment.length > 60 && (
                      <div
                        className="text-more"
                        onClick={() => setExpanded((prev) => !prev)}
                      >
                        {expanded ? t("Show less ▲") : t("See more ▼")}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    minWidth: "70px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block"
                    }}
                  >
                    <FaRegCommentDots
                      size={24}
                      color="#162955"
                      style={{ cursor: "pointer" }}
                      onClick={async () => {

                        if (selectedReview?.id_review === item.id_review && openChat) {

                          setOpenChat(false);

                        } else {

                          setSelectedReview(item);

                          await dispatch(
                            getReviewChatAction({
                              id_review: item.id_review,
                              reader: "customer",
                            })
                          );

                          await dispatch(
                            getUnreadReviewChatAction({
                              idUserTMY
                            })
                          );

                          setOpenChat(true);

                        }

                      }}
                    />

                    {unreadReviewChat.some(
                      x => x.id_review === item.id_review
                    ) && (

                        <span className="chat-notification" />

                      )}

                  </div>

                  {openChat && selectedReview?.id_review === item.id_review && (
                    <div className="chat-overlay">
                      <div className="chat-modal">
                        <div className="chat-header">
                          <b className="chat-m">{t("Chat")}</b>

                          <button
                            onClick={() => setOpenChat(false)}
                            className="btn-close-chat2"
                          >
                            &times;
                          </button>

                        </div>

                        <div className="chat-body">
                          {/* <div
                            style={{
                              textAlign: "center",
                              color: "#999",
                              fontSize: 12,
                            }}
                          >
                            Review ID : {item.id_review}
                          </div> */}

                          {/* Admin */}
                          {reviewChat.map((msg, index) => (
                            <div
                              key={index}
                              className={`chat-row ${msg.sender_type === "customer"
                                ? "customer"
                                : "admin"
                                }`}
                            >
                              {/* Wrapper ของ Bubble + Read Status */}
                              <div
                                className={`chat-message ${msg.sender_type === "customer"
                                  ? "customer"
                                  : "admin"
                                  }`}
                              >
                                {/* Bubble */}
                                <div
                                  className={`chat-bubble ${msg.sender_type === "customer"
                                    ? "customer"
                                    : "admin"
                                    }`}
                                >
                                  {isUrl(msg.message) ? (
                                    <a
                                      href={msg.message}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color:
                                          msg.sender_type === "customer"
                                            ? "#fff"
                                            : "#162955",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      {msg.message}
                                    </a>
                                  ) : (
                                    msg.message
                                  )}

                                  {msg.file_url && (
                                    <div style={{ marginTop: 8 }}>
                                      {msg.file_type?.startsWith("image") ? (
                                        <img
                                          src={msg.file_url}
                                          alt={msg.file_name}
                                          style={{
                                            width: 120,
                                            borderRadius: 8,
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            openFile(
                                              msg.file_url,
                                              msg.file_type,
                                              msg.file_name
                                            )
                                          }
                                        />
                                      ) : (
                                        <div
                                          style={{
                                            cursor: "pointer",
                                            color:
                                              msg.sender_type === "customer"
                                                ? "#fff"
                                                : "#162955",
                                            fontWeight: 500,
                                          }}
                                          onClick={() =>
                                            openFile(
                                              msg.file_url,
                                              msg.file_type,
                                              msg.file_name
                                            )
                                          }
                                        >
                                          📄 {msg.file_name}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>

                                {/* Read Status */}
                                {msg.sender_type === "customer" &&
                                  lastCustomerMessage?.id_reviewChat ===
                                  msg.id_reviewChat &&
                                  Number(msg.is_read) === 1 && (
                                    <div className="chat-read">
                                      {t("Read")}
                                    </div>
                                  )}
                              </div>
                            </div>
                          ))}

                          <div ref={chatBottomRef} />
                        </div>

                        <div className="chat-footer">
                          {/* Preview File */}

                          {chatFiles.length > 0 && (
                            <div className="chat-preview">
                              <div className="chat-preview-file">
                                <span>{chatFiles[0].name}</span>

                                <button
                                  type="button"
                                  className="chat-preview-remove"
                                  onClick={handleRemoveFile}
                                >
                                  ✕
                                </button>
                              </div>
                            </div>
                          )}

                          <div className="chat-toolbar">
                            {/* Attach */}

                            <label className="chat-icon-btn">
                              <FaPaperclip style={{ display: "block" }} size={18} color="#555" />

                              <input
                                hidden
                                type="file"
                                onChange={handleFileChange}
                              />
                            </label>

                            {/* Image */}

                            <label
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <FaImage style={{ display: "block" }} size={18} color="#555" />

                              <input
                                hidden
                                accept="image/*"
                                type="file"
                                onChange={handleFileChange}
                              />
                            </label>

                            {/* Emoji */}

                            <div
                              ref={emojiContainerRef}
                              className="chat-icon-btn chat-emoji"
                            >
                              <FaSmile
                                size={18}
                                color="#555"
                                style={{
                                  display: "block",
                                  cursor: "pointer",
                                  marginBottom: "7px",
                                }}
                                onClick={() => setShowEmoji((prev) => !prev)}
                              />

                              {showEmoji && (
                                <div className="chat-emoji-picker">
                                  <EmojiPicker
                                    onEmojiClick={(emojiData) => {
                                      setChatMessage((prev) => prev + emojiData.emoji);
                                    }}
                                  />
                                </div>
                              )}
                            </div>

                            {/* Input */}

                            <input
                              value={chatMessage}
                              onChange={(e) => setChatMessage(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                  e.preventDefault();
                                  handleSendChat();
                                }
                              }}
                              placeholder={t("Type message...")}
                              className="chat-input"
                            />

                            {/* Send */}

                            <button
                              onClick={handleSendChat}
                              className="chat-send"
                            >
                              <FaPaperPlane />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="text-muted-auto">
                    {(() => {
                      const rawDate = matchedBooking?.activity_date;
                      if (!rawDate) return "-";

                      const rawDateStr = String(rawDate);
                      const lastDateStr = rawDateStr.includes(",")
                        ? rawDateStr.split(",").pop().trim()
                        : rawDateStr;

                      const formattedDateStr = lastDateStr.replace(/\//g, "-");
                      const dateObj = new Date(formattedDateStr);

                      if (isNaN(dateObj)) return "-";

                      return getFlexibleDistanceToNow(dateObj);
                    })()}
                  </div>
                </div>
                {/* <div
                  className="text-muted-auto"
                >
                  {(() => {
                    const rawDate = matchedBooking?.activity_date;
                    if (!rawDate) return "-";

                    const rawDateStr = String(rawDate); // แปลงเป็น string
                    const lastDateStr = rawDateStr.includes(",")
                      ? rawDateStr.split(",").pop().trim()
                      : rawDateStr;

                    const formattedDateStr = lastDateStr.replace(/\//g, "-");
                    const dateObj = new Date(formattedDateStr);
                    if (isNaN(dateObj)) return "-";

                    return getFlexibleDistanceToNow(dateObj);
                  })()}
                </div> */}
              </div>
            );
          })}

          {renderPagination(userReviews.length, historyPage, setHistoryPage)}
        </div>
      );
    }
  };

  return (
    <>
      <div className="py-custom-space">
        <div className="text-center">
          <img
            className="BoatHelm-1 mb-1vh"
            draggable={false}
            src={BoatHelm}
            alt="BoatHelm"
          />
          <h3>{t("Review(s)")}</h3>
        </div>

        {/* Tabs */}
        <div
          className="flex-border-bottom mt-4vh"
        >
          <div
            onClick={() => setActiveTab("toBeReviewed")}
            style={{
              cursor: "pointer",
              padding: "8px 16px",
              fontWeight: activeTab === "toBeReviewed" ? "600" : "400",
              color: activeTab === "toBeReviewed" ? "#162955" : "#c1c1c1",
              borderBottom:
                activeTab === "toBeReviewed" ? "3px solid #162955" : "none",
            }}
          >
            {t("To Be Reviewed")}
          </div>
          <div
            onClick={() => setActiveTab("history")}
            style={{
              cursor: "pointer",
              padding: "8px 16px",
              fontWeight: activeTab === "history" ? "600" : "400",
              color: activeTab === "history" ? "#162955" : "#c1c1c1",
              borderBottom:
                activeTab === "history" ? "3px solid #162955" : "none",
            }}
          >
            {t("History")}
          </div>
        </div>

        {/* Tab Content */}
        {renderTabContent()}
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {loading && (
        <div
          className="fullscreen-overlay"
          aria-label="Loading"
          role="status"
        >
          <img
            src={Sail} // ถ้าใช้ไฟล์ใน public ให้เปลี่ยนเป็น "/Sail.gif"
            alt="Loading..."
            className="image-modal"
            draggable={false}
          />
        </div>
      )}
    </>
  );
};

export default Reviews;
